var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 12.5,
    cy: 12,
    r: 12,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7927 6.85356C20.1833 7.24409 20.1833 7.87725 19.7927 8.26778L10.9141 17.1465C10.5235 17.537 9.89037 17.537 9.49985 17.1465L5.20696 12.8536C4.81643 12.463 4.81643 11.8299 5.20696 11.4393C5.59748 11.0488 6.23065 11.0488 6.62117 11.4393L10.207 15.0251L18.3785 6.85356C18.7691 6.46304 19.4022 6.46304 19.7927 6.85356Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.d73ebf444468b8354348c518191d4229.svg";
export { ForwardRef as ReactComponent };